import { useQuery } from "react-query";

import { commentQueries } from "@/react/lib/queries/comments";

interface UseCommentHierarchyParams {
  id: number;
  postId: number;
}

export const useCommentHierarchy = ({
  postId,
  id,
}: UseCommentHierarchyParams) => {
  const { data: comment, isPending } = useQuery(
    commentQueries.hierarchy({ postId, id }),
  );

  return { comment, isPending };
};
